



























import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/table/TableComponent.vue";
import formatDate from "@/lib/formatDate";
import CButton from "@/basics/buttons/CButton.vue";
import DeleteModal from "@/components/modal/DeleteModal.vue";

@Component({
  components: {
    TableComponent,
    CButton,
    DeleteModal
  }
})
export default class AlertRoomAutoLockList extends Vue {
  @Prop({ type: Array, required: true }) items!: any;

  deleteModal: boolean = false;
  deleted: boolean = false;
  
  formatDate(time: number): string {
    return formatDate(new Date(time));
  }

  send(alertId: string) {
    const value = alertId;
    this.$emit("send", value);
  }
}
